export default __webpack_public_path__ + "ea3a59eb9d4bc4cd71e9ed5da1691fb8.jpg";